import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';
import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';
import styles from './styles/MotivationStepButton.scss';

const MotivationStepButton = ({ selectedMotivationState, dispatch }) => {
  const { t } = useTranslation();

  const handleMotivationStepButtonChange = value => {
    if (value !== null) dispatch(change(CLIENT_ALLOWANCE_FORM, 'motivationState', value));
  };

  const defaultWorkType = [
    {
      value: 'fulltime',
      label: t('features.ClientMotivation.global.fulltime')
    },
    {
      value: 'probation',
      label: t('features.ClientMotivation.global.probation')
    }
  ];

  return (
    <div className={styles.radioButtonGroup}>
      {defaultWorkType.map(type => {
        const isSelected = selectedMotivationState === type.value;

        return (
          <button
            key={type.value}
            type="button"
            className={`${styles.radioButton} ${isSelected ? styles.selected : ''}`}
            onClick={() => handleMotivationStepButtonChange(type.value)}
          >
            {type.label}
          </button>
        );
      })}
    </div>
  );
};

const mapStateToProps = state => ({
  selectedProbationStep: selector(getAllowanceFormValues(state), 'probationStep'),
  selectedMotivationState: selector(getAllowanceFormValues(state), 'motivationState')
});

export default connect(mapStateToProps)(MotivationStepButton);
